import { ILeaderboardConfig, SocialInterest } from 'fitbeat.models';
import moment from 'moment';
import React, { CSSProperties } from 'react';
import Checkbox from '../../../shared/components/Checkbox';

export interface IInterestGroupSettingsTabProps {
  formData: ILeaderboardConfig;
  isUpdate: boolean;
  handleInputChange: (
    e: React.ChangeEvent<HTMLInputElement>
    | React.ChangeEvent<HTMLSelectElement>
    | React.ChangeEvent<HTMLTextAreaElement>,
  ) => void;
  handleCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const socialInterestOptions = Object.values(SocialInterest)
  .map((socialInterest) => ({
    socialInterest,
    name: socialInterest.replace(/([a-z])([A-Z])/g, '$1 $2'),
  }))
  .sort((a, b) => a.name.localeCompare(b.name));

const InterestGroupSettingsTab: React.FC<IInterestGroupSettingsTabProps> = ({
  formData,
  isUpdate,
  handleInputChange,
  handleCheckboxChange,
}) => (
  <div style={styles.formColumn}>
    <h3 style={styles.columnHeader} className='leaderboard-create-headers'>
      Interest Group
    </h3>
    <label style={styles.inputLabel}>
      Group Name:
      <input
        type='text'
        name='name'
        value={formData.name}
        onChange={handleInputChange}
        required
        style={styles.inputField}
      />
    </label>
    <label style={styles.inputLabel}>
      Description (optional):
      <textarea
        name='description'
        value={formData.description ?? ''}
        onChange={handleInputChange}
        rows={3}
        style={styles.textAreaField}
      />
    </label>
    <label style={styles.inputLabel}>
      Social Interest:
      <select
        name='socialInterest'
        value={formData.socialInterest ?? ''}
        onChange={handleInputChange}
        required
        style={styles.inputField}
      >
        <option value='' disabled>Select a social interest</option>
        {socialInterestOptions.map((option) => (
          <option key={option.socialInterest} value={option.socialInterest}>
            {option.name}
          </option>
        ))}
      </select>
    </label>
    <label style={styles.inputLabel}>
      Header Image URL (optional):
      <input
        type='url'
        name='headerImageUrl'
        value={formData.headerImageUrl ?? ''}
        onChange={handleInputChange}
        placeholder='https://'
        style={styles.inputField}
      />
    </label>
    <label style={styles.inputLabel}>
      Order:
      <input
        type='number'
        name='order'
        value={formData.order}
        onChange={handleInputChange}
        required
        min={1}
        style={styles.inputField}
      />
    </label>
    <label style={styles.inputLabel}>
      Start Date:
      <input
        type='date'
        name='startDate'
        value={moment(formData.startDate).tz(formData.timezone).format('YYYY-MM-DD')}
        onChange={handleInputChange}
        required
        style={styles.inputField}
        disabled={isUpdate}
      />
    </label>
    <label style={styles.inputLabel}>
      End Date (optional):
      <input
        type='date'
        name='endDate'
        value={formData.endDate ? moment(formData.endDate).tz(formData.timezone).format('YYYY-MM-DD') : ''}
        onChange={handleInputChange}
        style={styles.inputField}
      />
    </label>
    <Checkbox
      onClick={() => handleCheckboxChange({
        target: {
          name: 'isEnabled',
          checked: !formData.isEnabled,
        },
      } as React.ChangeEvent<HTMLInputElement>)}
      isChecked={formData.isEnabled}
      labelText='Enable interest group'
      labelClass=''
    />
  </div>
);

const styles: { [key: string]: CSSProperties } = {
  formColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    width: '100%',
    maxWidth: '480px',
    margin: '0 auto',
  },
  columnHeader: {
    margin: 0,
  },
  inputLabel: {
    display: 'flex',
    fontWeight: 'bold',
    flexDirection: 'column',
  },
  inputField: {
    padding: '8px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    fontSize: '14px',
    marginTop: '4px',
  },
  textAreaField: {
    padding: '8px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    fontSize: '14px',
    marginTop: '4px',
    fontFamily: 'inherit',
    resize: 'vertical',
  },
};

export default InterestGroupSettingsTab;
